import React, { Component } from "react";
import { Form, TextArea, Radio, RadioGroup } from "informed";
import { Link } from "react-router-dom";

import DropDownSelect from "./../../common/form-fields/drop-down/DropDownSelect";
import EditText from "./../../common/form-fields/edit-text/EditText";
import MaskValidateUtil from "../../common/util/MaskValidateUtil";
import Loader from "../../common/loader/Loader";
import ErrorView from "../../common/error-view/ErrorView";
import {  AppLinks} from "../../../constants/app-links";

import { cancelPolicy } from "../../../api/accounts-api";

import DontCancelYet from "../dontCancelYetComponent/dont-cancel-yet-component";

import "./cancel-component.css";

const NO_LONGER_OWN_PET = "I no longer own my pet";
const PET_PASSED_AWAY = "My pet passed away";

const PLEASE_SELECT_ONE = "Please select one";
export default class CancelComponent extends Component {
  constructor() {
    super();
    this.errorText = null;
    this.state = {
      options: [
        {
          displayName:
            "Please select one",
          value:
            "Please select one"
        },
        {
          displayName:
            "I am canceling due to pre-existing conditions restricting my coverage",
          value:
            "I am canceling due to pre-existing conditions restricting my coverage"
        },
        {
          displayName:
            "I am dissatisfied with the service or with the handling of a claim",
          value:
            "I am dissatisfied with the service or with the handling of a claim"
        },
        {
          displayName: "The monthly premium does not fit into my budget     ",
          value: "The monthly premium does not fit into my budget     "
        },
        {
          displayName: "I do not see the value of pet insurance",
          value: "I do not see the value of pet insurance"
        },
        {
          displayName: "I no longer own my pet",
          value: "I no longer own my pet"
        },
        {
          displayName: "My pet passed away",
          value: "My pet passed away"
        }
      ],
      showDontCancel: false,
      sendingToServer: false,
      serverError: false,
      cancelReason: '',
      accountOrPetID: '',
    };

     //For google analytics
     window.dataLayer.push({
      'event': 'Pageview',
      'url': window.location.pathname + '/Step1'
    });
  }


  petOrAccountChoices = () => {
    return (
      <div>
        <strong>
          Cancel a pet or your account?
        </strong>
        <RadioGroup required field='accountOrPetID' onValueChange={val => this.setPetOrAccountChoice(val)}>
          { this.props.petDetails.map((pet, index) => {
            return (
              <div class="cancelReasonCol">
                <Radio value={pet.PetID} label={pet.Name} id={"radio-" + pet.PetID} /> {pet.Name}
              </div>
            )
            }) }
            <div>
              <Radio value='cancelAccount' label='Cancel Account' id='radio-CancelAccount' /> Cancel Account
            </div>
        </RadioGroup>
      </div>
    )
  }


  cancelReasons = (formState) => {
    return (
      <div className="cancelReasons">
        <strong>
          Why are you cancelling?
        </strong>
        <RadioGroup required field='cancelReason' onValueChange={val => this.setCancelReason(val)}>
          <div class="row">
            <div class="col-md-6 left cancelReasonCol"><Radio value="NO_LONGER_OWN_PET" label="I don't own this pet anymore" /> I don't own this pet anymore</div>
            <div class="col-md-6 cancelReasonCol"><Radio value="DO_NOT_SEE_VALUE" label="I don't see the value" /> I don't see the value</div>
          </div>
          <div class="row">
            <div class="col-md-6 left cancelReasonCol"><Radio value="PET_PASSED_AWAY" label="My pet has passed away" /> My pet has passed away</div>
            <div class="col-md-6 cancelReasonCol"><Radio value="BAD_CUSTOMER_EXPERIENCE" label="I had a bad customer service experience" /> I had a bad customer service experience</div>
          </div>
          <div class="row">
            <div class="col-md-6 left cancelReasonCol"><Radio value="PREMIUM_TOO_HIGH" label="The premium is too high" /> The premium is too high</div>
            <div class="col-md-6 cancelReasonCol"><Radio value="POLICY_DOES_NOT_WORK" label="The policy doesn't work for me" /> The policy doesn't work for me</div>
          </div>
        </RadioGroup>
        <div class="row">
          <div class="col-12">
            <TextArea
              placeholder="Please tell us more."
              className="mt-2 cancelReasons-textarea"
              id="cancelReasons-textarea"
              type="text"
              title="Please tell us more."
              floatingTitle={false}
              field="cancelReasonText"
            />
          </div>
        </div>
        {this.state.cancelReason == 'PET_PASSED_AWAY' ? 
          <React.Fragment>
            <div class="row">
              <div class="col-12">
                <strong>Please enter the date the pet passed away</strong>
                <p className="deepest-sympathies">
                  <img className="deepest-sympathies-ribbon" src="../../assets/images/normal_u517.png" alt="Black ribbon" />
                  Our deepest sympathies to you and your family for your loss.
                </p>
                <p>Please enter the date of your pet's passing to continue.</p>
                <EditText
                  required
                  className="mt-3 date-container"
                  id="passingDate"
                  type="text"
                  title="Date of Passing (MM/DD/YYYY)"
                  floatingTitle={true}
                  field="passingDate"
                  mask={MaskValidateUtil.dateMask}
                  validate={MaskValidateUtil.validateDateWithNow}
                  validateOnBlur
                  validateOnChange={formState.errors.date}
                />
              </div>
            </div>

          </React.Fragment> : null 
        }
        {this.state.cancelReason === 'DO_NOT_SEE_VALUE' || 
          this.state.cancelReason === 'BAD_CUSTOMER_EXPERIENCE' || 
          this.state.cancelReason === 'PREMIUM_TOO_HIGH' || 
          this.state.cancelReason === 'POLICY_DOES_NOT_WORK' ? 
          <React.Fragment>
            <div class="row">
              <div class="col-12 my-3">
                <strong>Select the desired cancel date.</strong>
              </div>
            </div>
             <RadioGroup required field='cancelDate'>
              <div class="row">
                <div class="col-12 cancelReasonCol"><Radio value="END_OF_BILLING_PERIOD" label="Cancel end of billing period" selected /> Cancel end of billing period</div>
              </div>
              <div class="row">
                <div class="col-12 cancelReasonCol"><Radio value="IMMEDIATELY" label="Cancel immediately" /> Cancel immediately</div>
              </div>
            </RadioGroup>
          </React.Fragment> : null  
        }
      </div>
    )
  }


  setCancelReason = (value) => {
    this.setState({
      cancelReason: value
    })
  }


  setPetOrAccountChoice = (value) => {
    this.setState({
      accountOrPetID: value
    })
  }


  validateContinueButton = (formState, numPets) => {
    
    let valid = true;

    if(numPets > 1 && formState.values.accountOrPetID == null) {
      valid = false;
    }

    if(formState.values.cancelReason == null) {
      valid = false;
    }

    if (formState.values.cancelReason === "PET_PASSED_AWAY") {
      if (formState.values.passingDate == null || formState.values.passingDate === "") {
        valid = false;
      }
    }

    if (formState.values.cancelReason === "DO_NOT_SEE_VALUE" || 
        formState.values.cancelReason === 'BAD_CUSTOMER_EXPERIENCE' || 
        formState.values.cancelReason === 'PREMIUM_TOO_HIGH' || 
        formState.values.cancelReason === 'POLICY_DOES_NOT_WORK') {
          if (formState.values.cancelDate == null) {
            valid = false;
          }
        }

    if (valid) {
      return "button-primary-plus button-container";
    } else {
      return "button-primary-plus button-container disabled-btn";
    }
  }


  cancelPolicy = values => {

    if (this.props.petDetails.length == 1) {
      values.accountOrPetID = "cancelAccount";
    }
  
    this.setState({
      accountOrPetID: values.accountOrPetID
    });

    if(values.accountOrPetID == null) {

      this.errorText =  "Please select a pet or your entire account";
        this.setState({
          sendingToServer: false,
          serverError: true
        });
        window.scrollTo(0, 0);
        return;
    }

    if(values.cancelReason == null) {

      this.errorText =  "Please select a cancellation reason";
        this.setState({
          sendingToServer: false,
          serverError: true
        });
        window.scrollTo(0, 0);
        return;
    }


    // set the data for the confirm page
    // pet name is either one or all
    let petNameList = "";
    if (values.accountOrPetID === "cancelAccount" || values.accountOrPetID === "") {

      if (this.props.petDetails.length == 1) {
        petNameList = this.props.petDetails[0].Name;
      } else if (this.props.petDetails.length == 2) {
        petNameList = this.props.petDetails[0].Name + " and " + this.props.petDetails[1].Name;
      } else {
        for (let i=0; i < this.props.petDetails.length; i++) {
          petNameList = petNameList + this.props.petDetails[i].Name;

          if (i === this.props.petDetails.length - 1) {
            break;
          } else if (i === this.props.petDetails.length - 2) {
            petNameList = petNameList + ", and ";
          } else {
            petNameList = petNameList + ", ";
          }
        }  
      }
    } else {
      for (let i=0; i < this.props.petDetails.length; i++) {
        if (this.props.petDetails[i].PetID === values.accountOrPetID) {
          petNameList = this.props.petDetails[i].Name;
        }
      }
    }

    // Get account or pet id
    let objectId = '';
    let objectType = '';
    if (values.accountOrPetID === "cancelAccount") {
      objectId = this.props.userAccountDetails.AccountID;
      objectType = 'ACCOUNT';
    } else {
      objectId = values.accountOrPetID;
      objectType = 'PET';
    }

    // If they no longer own the pet, use IMMEDIATELY as the cancel effective date
    if (values.cancelReason === 'NO_LONGER_OWN_PET') {
      values.cancelDate = "IMMEDIATELY";
    }

    // calculate cancel date
    let cancelEffectiveDate = new Date();
    if (values.cancelDate == "END_OF_BILLING_PERIOD") {
      cancelEffectiveDate = new Date(this.props.userAccountDetails.PaidThroughDate);
    } else if (values.cancelDate == "IMMEDIATELY") {
      cancelEffectiveDate = new Date();
    }

    // calculate pet left date
    let petLeftDate = null;
    if (values.cancelReason === 'PET_PASSED_AWAY') {
      petLeftDate = new Date(values.passingDate);
      cancelEffectiveDate = new Date(values.passingDate);
    }

    // increment cancelEffectiveDate to next day midnight
    if(values.cancelDate !== "END_OF_BILLING_PERIOD"){
      cancelEffectiveDate.setDate(cancelEffectiveDate.getDate() + 1);
    }
    cancelEffectiveDate.setHours(0,0,0,0);

    let cancelData = {
      email: this.props.userAccountDetails.PetParentInfo.Email,
      object_id: objectId,
      object_type: objectType,
      refund_option: values.cancelDate,
      cancel_reason: values.cancelReason,
      comments: values.cancelReasonText,
      cancel_effective_date: cancelEffectiveDate,
      pet_names: petNameList,
      pet_left_date: petLeftDate
    };

    cancelData.cancelEffectiveDate = cancelEffectiveDate;

    this.props.setData(cancelData, cancelEffectiveDate);

  
    // decide to show Don't Cancel Yet page or not
    if (values.cancelReason === 'DO_NOT_SEE_VALUE' ||
      values.cancelReason === 'BAD_CUSTOMER_EXPERIENCE' ||
      values.cancelReason === 'PREMIUM_TOO_HIGH' ||
      values.cancelReason === 'POLICY_DOES_NOT_WORK') {

        // show the Don't Cancel Yet page
        this.setState({
          showDontCancel: true,
        });

    } else {

      // move to Cancel Confirm page, don't show the Don't Cancel Yet page
      this.props.stepper.nextStep();
    }
  };

  continueToCancel = (values) => {
    
    this.props.stepper.nextStep();
  }

  
  render() {
    return (
      <React.Fragment>
        {this.state.showDontCancel ? (
          <DontCancelYet {...this.props } cancelReason={this.state.cancelReason} accountOrPetID={this.state.accountOrPetID}
            continueToCancel={this.continueToCancel} />
        ) : (
          <div className="container cancel-component">
            <div>
              <div className="row">
                <div className="col-12">
                  <h1 className="title-container d-flex align-items-center">
                    Cancel Your Insurance Policy
                  </h1>
                </div>
              </div>
              {this.state.serverError && (
                <ErrorView>{this.errorText? this.errorText: 
                  <span>Unable to fetch policy expiry date. Please <Link to={AppLinks.others.contact}>click here</Link> to contact us.</span>
                }</ErrorView>
              )}
              <Form onSubmit={values => this.cancelPolicy(values)}>
              {({ formState }) => (
                <React.Fragment>
                  <div className="row">
                    <div className="col-12">
                      <p className="mb-0">
                        <strong>
                          We're sorry you want to cancel, please help us understand more about your decision. 
                        </strong> If you want to keep your account 
                        and cancel multiple pets please run through the cancel process for each pet. See our <Link to={AppLinks.faq.faq}>FAQ's</Link> for any questions.
                      </p>
                      <br></br>
                      <p>

                        { this.props.petDetails.length > 1 ? this.petOrAccountChoices(this.props.petDetails) : null }
                      </p>
                      {/*
                      <p>
                        Before you cancel, please help us understand more about your
                        decision. Using the form below will cancel all of your pets'
                        policies. If you wish to remove one pet from coverage,
                        please send us a request through{" "}
                        <Link to={AppLinks.others.contact}>contact us</Link> page.
                      </p>
                      */}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      { this.cancelReasons(formState) }

                      <div className="d-flex flex-column flex-md-row mt-3 mb-4">
                        <button className={ this.validateContinueButton(formState, this.props.petDetails.length) }>
                          Continue
                        </button>
                      </div>

                    </div>
                  </div>
                </React.Fragment>
                )}
              </Form>
            </div>
          </div>
        )}
        {this.state.sendingToServer && <Loader position="absolute" fullPage={true} />}
      </React.Fragment>
    );
  }

  isDeceased = reason => {
    return reason === "PET_PASSED_AWAY";
  };
  isLost = reason => {
    return reason === NO_LONGER_OWN_PET || reason === PET_PASSED_AWAY;
  };
}
